var map = {
	"./autumn-puzzle.json": 76078,
	"./christmas-tiles.json": 70003,
	"./christmas-wordsearch.json": 61406,
	"./cute-puzzle.json": 82813,
	"./how-to-play-tiles.json": 10458,
	"./our-games.json": 51363,
	"./test.json": 12893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58982;